import { useSelector } from 'react-redux';

import { selectUser } from 'features/auth/authSelectors';

import { AppModules, ClientTierAppModules } from 'constants/enums';

const APP_MODULES_MAPPING = {
  [AppModules.Applications]: ClientTierAppModules.Applications,
  [AppModules.Jobs]: ClientTierAppModules.Jobs,
  [AppModules.Jobseekers]: ClientTierAppModules.Jobseekers,
  [AppModules.Ace]: ClientTierAppModules.Ace,
  [AppModules.RecruitmentOverviewReport]: ClientTierAppModules.Analytics
} as Record<AppModules, ClientTierAppModules>;

const useModuleAccess = () => {
  const user = useSelector(selectUser);
  const availableModules =
    user?.clientTierConfiguration?.availableModules || [];

  const hasAccess = (module: AppModules) => {
    const mappedModule = APP_MODULES_MAPPING[module];

    return availableModules.includes(mappedModule);
  };

  return hasAccess;
};

export default useModuleAccess;
